import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CountryLookupModel } from 'app/generated/backend/locality/api/country-lookup-model';

@Injectable()
export class CountryLookupHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
	): Observable<JsonResourceResponse<CountryLookupModel[]>> {
		return this.http.get<JsonResourceResponse<CountryLookupModel[]>>('api/v1/locality/countries/lookup').pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		CountryLookupHandlerService
	]
})
export class CountryLookupHandlerModule { }
